
/**
 * 进度条
 */
export default {
  props: {
    items: {
      type: Array,
      default(): string[] {
        return ["Step 1", "Step 2", "Step 3"];
      },
    },
  },
  data():any {
    return {
      current: 0,
    };
  },
  methods: {
    /**
     *
     * @param i
     */
    go(i: number): void {
      this.current = i;
    },

    /**
     *
     */
    perv(): void {
      let perv: number = this.current - 1;
      if (perv < 0) perv = this.items.length - 1;

      this.go(perv);
    },

    /**
     *
     */
    next(): void {
      let next: number = this.current + 1;
      if (this.items.length == next) next = 0; // 循环

      this.go(next);
    },
  },
};
